import { SagaIterator } from "redux-saga";
import { call, put, takeEvery } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading } from "../../repository/slice";

function* deleteAnswerWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.delete, "/api/admin/answer/delete/" + payload.id);
    } catch (error) {
        console.error("deleteAnswerWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* deleteAnswerWatcher() {
    yield takeEvery("@saga/DELETE_ANSWER", deleteAnswerWorker);
};
